(() => {
  const replacements = new Map([
    [
      'Choose a print world on the left, then explore the pieces inside it. Product videos play only when they are visible.',
      'Explore the collections below and discover the pieces in each print story.'
    ],
    ['Collection index', 'Collections'],
    ['Choose a story', 'Explore collections'],
    ['View every collection', 'View all collections'],
    [
      'A relaxed A-line dress with pockets in an original ByZayn print. I have it made after you order, and I am here if you would like help choosing your size.',
      'A relaxed A-line dress with pockets, made in our original Retro Wave print. Each piece is made to order, and I’m here to help with sizing.'
    ],
    [
      'Questions before ordering? Write to me — I usually reply within a few hours, seven days a week.',
      'Need help before ordering? Send me a message — I usually reply within a few hours.'
    ],
    [
      'Every product order includes a complimentary tote in the matching print, personalized with the name you choose. These are real examples we have already prepared.',
      'Every order includes a complimentary tote in the same print, personalized with the name you choose. The images below show examples we have made.'
    ],
    [
      'The names shown are personalization examples. Your tote will carry the name you enter on the product page.',
      'The names shown are examples. Your tote will be personalized with the name you enter on the product page.'
    ],
    [
      'Start with the prints that earned the most Etsy orders: Retro Wave, Retro Floral and Mediterranean Fish.',
      'Start with our most popular Etsy designs: Retro Wave, Retro Floral and Mediterranean Fish.'
    ],
    [
      'I am Zeynep, the founder of ByZayn. I answer sizing questions, follow your order and stay available until your parcel arrives. If something is wrong, I will look at it with you and work toward the fairest solution within our made-to-order policy.',
      'I’m Zeynep, founder of ByZayn. I can help with sizing, order updates and delivery questions. If something goes wrong, message me and I’ll work with you on the best solution available under our made-to-order policy.'
    ],
    [
      'Payments are processed through Shopify. Questions come directly to ByZayn.',
      'Payments are securely processed by Shopify, and your questions come directly to me.'
    ],
    ['What happens after you order.', 'From order to delivery.'],
    [
      'No mystery. Here is what happens from the moment you choose a piece until it reaches you.',
      'Here is what happens after you place your order.'
    ],
    ['Select the print, piece and size that feel right to you.', 'Choose your print, style and size.'],
    [
      'Tell us exactly what should appear on your complimentary tote.',
      'Enter the name you would like printed on your complimentary tote.'
    ],
    ['Your piece enters production after the order is placed.', 'Production begins after your order is placed.'],
    [
      'You receive tracking after dispatch. I stay available until it arrives and help directly if something is wrong.',
      'You receive tracking as soon as your order ships. I’m here if you need help before or after delivery.'
    ],
    ['Know the timing', 'Production and delivery'],
    ['Made-to-order returns', 'Returns policy'],
    ['Automatically Applied in Cart', 'Applied automatically at checkout'],
    ['Free Shipping on All Products', 'Free shipping on every order'],
    [
      'Automatically applied in your cart · no code needed · free shipping included',
      'Your discount is applied automatically at checkout and shipping is free.'
    ],
    ['Your website-exclusive discount', 'Your complimentary personalized tote and free standard shipping'],
    [
      'Automatically applied in this cart · no code needed · free shipping included',
      'Applied automatically at checkout, with free shipping included.'
    ]
  ]);

  const ignoredTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION']);
  let scheduled = false;

  const replaceText = (root) => {
    if (!root || !root.ownerDocument && root !== document) return;

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const parent = node.parentElement;
          if (!parent || ignoredTags.has(parent.tagName)) return NodeFilter.FILTER_REJECT;
          return node.nodeValue && node.nodeValue.trim()
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_REJECT;
        }
      }
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      let nextValue = node.nodeValue;
      replacements.forEach((replacement, original) => {
        if (nextValue.includes(original)) nextValue = nextValue.replaceAll(original, replacement);
      });
      if (nextValue !== node.nodeValue) node.nodeValue = nextValue;
    });
  };

  const cleanInterface = (root = document) => {
    try {
      sessionStorage.removeItem('byzayn-sale-motion-paused');
    } catch (_) {}

    root.querySelectorAll?.('[data-zayn-sale-motion-control], .zayn-commerce-announcement__motion-control')
      .forEach((element) => element.remove());

    root.querySelectorAll?.('[data-zayn-sale-bar]')
      .forEach((bar) => {
        if (!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
          bar.dataset.paused = 'false';
        }
      });

    replaceText(root);
  };

  const scheduleClean = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      cleanInterface(document);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleClean, { once: true });
  } else {
    scheduleClean();
  }

  const observer = new MutationObserver(scheduleClean);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });

  window.addEventListener('pageshow', scheduleClean);
  document.addEventListener('shopify:section:load', scheduleClean);
})();
